import React, { useState } from "react";
import styles from "../pages/mainpage/MainPage.module.css";
import ImageGallery from "react-image-gallery";
import LeftNav from "../util/LeftNav";
import RightNav from "../util/RightNav";

const Gallery = ({
  images,
  closeGallery,
}: {
  images: string[];
  closeGallery: () => void;
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLastImageDisplayed, setIsLastImageDisplayed] = useState(false);
  const items = [
    ...images.map((image) => ({
      original: image,
      thumbnail: image,
    })),
  ].filter((item) => item.original !== "");

  return (
    <div className={styles.modal}>
      <ImageGallery
        infinite={false}
        showPlayButton={false}
        showFullscreenButton={false}
        onSlide={(currentIndex) => {
          setCurrentIndex(currentIndex);
          if (currentIndex === items.length - 1) {
            if (isLastImageDisplayed) {
              closeGallery();
            } else {
              setIsLastImageDisplayed(true);
            }
          } else {
            setIsLastImageDisplayed(false);
          }
        }}
        onClick={() => {
          if (isLastImageDisplayed) {
            closeGallery();
          }
        }}
        items={items}
        renderLeftNav={(onClick, disabled) => {
          if (currentIndex === 0) {
            return null;
          }
          return <LeftNav disabled={disabled} onClick={onClick} />;
        }}
        renderRightNav={(onClick, disabled) => {
          if (currentIndex === items.length - 1) {
            return null;
          }
          return <RightNav disabled={disabled} onClick={onClick} />;
        }}
      />
    </div>
  );
};

export default Gallery;
